import { doSignInAnonymously } from './firebase-auth-service';
export async function signinUser() {
    const { user } = await doSignInAnonymously();
    return user;
}
